import * as selectors from 'map/selectors'
import { locationValueSelector } from 'search/selectors'
import ResultListComponent from 'map/components/resultList/ResultsList'
import ResultsListItem from 'map/components/resultsListItem'

const ResultsList = ({ activeLocation, loading, results, resultsCount, ratesError, location }) => {
    const hasResults = resultsCount > 0
    const getIsActive = id => (activeLocation ? id === activeLocation.id : true)

    return (
        <ResultListComponent loading={loading} hasResults={hasResults} ratesError={ratesError}>
            {hasResults &&
                results
                    .sort((a, b) => (a === location ? -1 : b === location ? 1 : 0))
                    .map(id => <ResultsListItem sfLocationId={id} active={getIsActive(id)} key={id} />)}
        </ResultListComponent>
    )
}

const mapStateToProps = createStructuredSelector({
    results: selectors.resultsSelector,
    activeLocation: selectors.activeLocationSelector,
    loading: selectors.loadingSelector,
    resultsCount: selectors.resultsCountSelector,
    ratesError: selectors.ratesErrorSelector,
    location: locationValueSelector,
})

export default connect(mapStateToProps)(ResultsList)
